import { Request } from '../../Servidor/Request';

export class TrapRequest {
    private sgepdenguearmadilha: number;
    private nome: string;

    constructor(sgepdenguearmadilha: number, nome: string) {
        this.sgepdenguearmadilha = sgepdenguearmadilha;
        this.nome = nome;
    }


    /**
     * Getter sgepdenguearmadilha
     * @return {number}
     */
    public getSgepDengueArmadilha(): number {
        return this.sgepdenguearmadilha;
    }

    /**
     * Getter nome
     * @return {string}
     */
    public getNome(): string {
        return this.nome;
    }
}

export class TrapStructRequest {
    private sgepdenguearmadilha: number;

    constructor(sgepdenguearmadilha: number) {
        this.sgepdenguearmadilha = sgepdenguearmadilha;
    }


    /**
     * Getter sgepdenguearmadilha
     * @return {number}
     */
    public getSgepDengueArmadilha(): number {
        return this.sgepdenguearmadilha;
    }

}

export class TrapStructResponse {
    private sgepdenguearmadilha: number;
    private nome: string;

    constructor(sgepdenguearmadilha: number, nome: string) {
        this.sgepdenguearmadilha = sgepdenguearmadilha;
        this.nome = nome;
    }


    /**
     * Getter sgepdenguearmadilha
     * @return {number}
     */
    public getSgepDengueArmadilha(): number {
        return this.sgepdenguearmadilha;
    }

    /**
     * Getter nome
     * @return {string}
     */
    public getNome(): string {
        return this.nome;
    }
}

export class TrapInteractor {
    public fetchSave(request: TrapRequest): PromiseLike<Boolean> {
        return new Promise((res, rej) => {
            return new Request().requestPost("dengue/armadilha/salvar", request).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                let response = rs.Status == "Sucesso"
                res(response)
            }, e => {
                rej(e);
            });
        });
    }

    public fetchDataOne(request: TrapStructRequest): PromiseLike<TrapStructResponse> {
        return new Promise((res, rej) => {
            return new Request().requestPost("dengue/armadilha/buscar", request).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }
}